import { render, staticRenderFns } from "./NavManager.vue?vue&type=template&id=3d7d8eb8&scoped=true"
import script from "./NavManager.vue?vue&type=script&lang=js"
export * from "./NavManager.vue?vue&type=script&lang=js"
import style0 from "./NavManager.vue?vue&type=style&index=0&id=3d7d8eb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d8eb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7d8eb8')) {
      api.createRecord('3d7d8eb8', component.options)
    } else {
      api.reload('3d7d8eb8', component.options)
    }
    module.hot.accept("./NavManager.vue?vue&type=template&id=3d7d8eb8&scoped=true", function () {
      api.rerender('3d7d8eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/NavManager.vue"
export default component.exports